import React, { useEffect, useState } from "react";
import { CardBody, Container as SContainer, InputGroup } from "shards-react";
import { strings } from "../../localization";
import PageTitle from "../../components/common/PageTitle";
import { Row, Col, Form, Button, Card, Image, Accordion, Modal } from "react-bootstrap";
import { FormGroup, FormInput } from "shards-react";
import { EntypoImage } from "react-entypo-icons";
import { ToastContainer, toast } from "react-toastify";
import "./RestaurantConfig.css";
import { API_URL, SLUG_URL } from "../../config";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import renderHTML from "react-render-html";
import swal from "sweetalert2";

const ImageContainer = ({ imgSrc, onDelete, alt }) => {
  return (
    <>
      <div className={imgSrc ? "imgBox" : "emptyImgBox"}>
        {imgSrc ? (
          <Image src={imgSrc} alt={alt} className="imgBox" thumbnail />
        ) : (
          strings.no_image_available
        )}
      </div>
      {imgSrc && (
        <div className="d-flex align-items-center">
          <div className="deleteBtnContainer" onClick={onDelete}>
            <span class="material-icons-outlined" style={{ color: "white" }}>
              delete
            </span>
          </div>
        </div>
      )}
    </>
  );
};

const RestaurantConfig = () => {
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [logoImage, setLogoImage] = useState(null);
  const [backgroundImageFile, setBackgroundImageFile] = useState(null);
  const [logoImageFile, setLogoImageFile] = useState(null);
  const [slug, setSlug] = useState("");
  const [organisationName, setOrganisationName] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [btnLoaderClass, setBtnLoaderClass] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [contactEmail, setContactEmail] = useState("");
  const [faqs, setFaqs] = useState([]);
  const [faqsLoading, setFaqsLoading] = useState(false);
  const [faqBtnLoaderClass, setFaqBtnLoaderClass] = useState("");
  const [isFaqButtonDisabled, setIsFaqButtonDisabled] = useState(false);

  const addFaq = () => {
    setFaqModalData({
      faqIndex: -1,
      question: "",
      answer: "",
      isNew: true
    });
    setShowFaqFormModal(true);
  };

  const openEditFaqModal = (faqIndex) => {
    const faq = faqs[faqIndex];
    setFaqModalData({
      faqIndex,
      question: faq.question ? faq.question.replace(/<[^>]*>/g, '') : "",
      answer: faq.answer,
      isNew: false
    });
    setShowFaqFormModal(true);
  };

  const handleSaveFaqFromModal = () => {
    const { faqIndex, question, answer, isNew } = faqModalData;
    const bodyData = { question, answer };

    setFaqBtnLoaderClass("fa fa-spinner fa-spin");
    setIsFaqButtonDisabled(true);

    const url = isNew ? `${API_URL}faq` : `${API_URL}faq/${faqs[faqIndex]._id || faqs[faqIndex].id}`;
    const method = isNew ? "POST" : "PUT";

    fetch(url, {
      method: method,
      credentials: "include",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    })
      .then((res) => {
        if (res.status == 200 || res.status == 201) {
          toast.success(strings.successfully_created || "FAQ saved successfully", {
            position: "top-right",
            autoClose: 2000,
          });
          setShowFaqFormModal(false);
          getFaqs(); // Re-fetch list after save
        } else {
          toast.error("Failed to save FAQ");
        }
        setFaqBtnLoaderClass("");
        setIsFaqButtonDisabled(false);
      })
      .catch((err) => {
        console.warn(err);
        toast.error("An error occurred while saving");
        setFaqBtnLoaderClass("");
        setIsFaqButtonDisabled(false);
      });
  };

  const removeFaq = (faqIndex) => {
    const faqId = faqs[faqIndex]._id || faqs[faqIndex].id;

    swal.fire({
      title: strings.are_you_sure,
      text: strings.delete_faq,
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: strings.yes_cancel,
      confirmButtonColor: "#2E209D",
      cancelButtonColor: "#D61E11",
      confirmButtonText: strings.yes_delete,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return fetch(`${API_URL}faq/${faqId}`, {
          method: "DELETE",
          credentials: "include",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
          }
        })
          .then(res => {
            if (res.status == 200) {
              return res.json();
            }
            throw new Error("Failed to delete FAQ");
          })
          .catch(err => {
            swal.showValidationMessage(`Request failed: ${err}`);
          });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        swal.fire(
          strings.deleted,
          strings.success_faq_deleted,
          "success"
        );
        getFaqs(); // Re-fetch list after delete
      }
    });
  };

  const updateFaq = (faqIndex, field, value) => {
    const newFaqs = [...faqs];
    newFaqs[faqIndex][field] = value;
    setFaqs(newFaqs);
  };

  const [activeAccordionKey, setActiveAccordionKey] = useState("0");
  const [showFaqFormModal, setShowFaqFormModal] = useState(false);
  const [faqModalData, setFaqModalData] = useState({
    faqIndex: -1,
    question: "",
    answer: "",
    isNew: false
  });

  const handleBackgroundChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackgroundImage(URL.createObjectURL(file));
      setBackgroundImageFile(file);
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoImage(URL.createObjectURL(file));
      setLogoImageFile(file);
    }
  };

  const onSaveConfig = () => {
    if (!primaryColor || !secondaryColor || !slug) {
      toast.error(strings.fill_fields, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else if (slug.length < 3) {
      toast.error(strings.slug_minimum_char_error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setBtnLoaderClass("fa fa-spinner fa-spin");
      setIsButtonDisabled(true);
      const bodyData = new FormData();
      bodyData.append("primaryColor", primaryColor);
      bodyData.append("secondaryColor", secondaryColor);
      bodyData.append("slug", slug);
      bodyData.append("contactEmail", contactEmail);

      if (backgroundImageFile) {
        bodyData.append("bgImage", backgroundImageFile);
      }

      if (logoImageFile) {
        bodyData.append("logo", logoImageFile);
      }

      console.log("bodyData", bodyData);
      fetch(`${API_URL}web-config`, {
        method: "PUT",
        credentials: "include",
        body: bodyData,
      })
        .then((res) => {
          console.log("response of web config post api", res);
          if (res.status == 200 || res.status == 201) {
            toast.success(strings.successfully_created, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setBtnLoaderClass("");
            setIsButtonDisabled(false);
          }
        })
        .catch((err) => {
          console.warn(err);
          setBtnLoaderClass("");
          setIsButtonDisabled(false);
        });
    }
  };

  const getOrganisationName = () => {
    let organizationData = JSON.parse(
      localStorage.getItem("organisation_info")
    );
    console.log("🚀 ~ RestaurantConfig ~ organizationData:", organizationData);
    let orgName = "";
    if (
      organizationData &&
      organizationData["data"] &&
      organizationData["data"]["name"]
    ) {
      orgName = organizationData["data"]["name"];
    }
    setOrganisationName(orgName);
    return orgName;
  };

  const getValueType = (value) => {
    if (Array.isArray(value)) return "array";
    if (value !== null && typeof value === "object") return "object";
    return typeof value;
  };

  const base64ToFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  const getRestaurantConfig = () => {
    setIsLoading(true);
    const orgName = getOrganisationName();
    fetch(`${API_URL}web-config`, {
      method: "get",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        console.log("response of web config get api", res);
        if (res.status == 200) {
          const parsedData = await res.json();
          console.log("parsedData of web config", parsedData);
          const valueType = getValueType(parsedData);
          if (valueType === "object" && Object.keys(parsedData).length > 0) {
            console.log("parsedData of web config if condition", parsedData);
            const id = parsedData["_id"];
            const data = parsedData["data"];
            const bgImage = data["bgImage"] || "";
            const bgImageFileName = data["bgImageName"] || "";
            const logoImage = data["logo"] || "";
            const logoImageFileName = data["logoName"] || "";
            setPrimaryColor(data["primaryColor"] || "");
            setSecondaryColor(data["secondaryColor"] || "");
            setSlug(data["slug"] || "");
            setContactEmail(data["contactEmail"] || "");
            if (bgImage.length > 0 && bgImageFileName.length > 0) {
              const bgImageBase64Str = `data:image/png;base64,${bgImage}`;
              const logoGeneratedFile = base64ToFile(
                bgImageBase64Str,
                bgImageFileName
              );
              setBackgroundImage(URL.createObjectURL(logoGeneratedFile));
              setBackgroundImageFile(logoGeneratedFile);
            }

            if (logoImage.length > 0 && logoImageFileName.length > 0) {
              const logoBase64Str = `data:image/png;base64,${logoImage}`;
              const logoGeneratedFile = base64ToFile(
                logoBase64Str,
                logoImageFileName
              );
              setLogoImage(URL.createObjectURL(logoGeneratedFile));
              setLogoImageFile(logoGeneratedFile);
            }
          } else {
            console.log("organisationName", orgName);
            if (orgName.length > 0) {
              setSlug(
                orgName
                  .trim()
                  .split(/\s+/)
                  .join("-")
                  .toLowerCase()
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.warn(err);
        setIsLoading(false);
      });
  };

  const getFaqs = () => {
    setFaqsLoading(true);
    fetch(`${API_URL}faq`, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (res.status == 200) {
          const parsedData = await res.json();
          const data = parsedData["result"] || parsedData["data"] || parsedData;

          if (Array.isArray(data)) {
            // Check if legacy categorized data is returned (unlikely on new endpoint but safe)
            if (data.length > 0 && data[0].category !== undefined) {
              const flattened = data.flatMap(cat => cat.faqs || []);
              setFaqs(flattened);
            } else {
              setFaqs(data);
            }
          } else {
            setFaqs([]);
          }
        }
        setFaqsLoading(false);
      })
      .catch((err) => {
        console.warn(err);
        setFaqsLoading(false);
      });
  };

  useEffect(() => {
    getRestaurantConfig();
    getFaqs();
  }, []);

  return (
    <SContainer fluid className="main-content-container px-4 mx-10">
      <Row>
        <Col>
          <Card small className="mb-4 tableCard mt-5">
            <CardBody className="p-3 b-3">
              <PageTitle
                sm="4"
                title={strings.restaurant_config}
                className="text-sm-left page-title"
              />
              <hr />
              {isLoading ? (
                <>Loading..</>
              ) : (
                <>
                  {/* Section: Colors */}
                  <h6 className="mb-3 fw-bold">🎨 {strings.colors}</h6>
                  <div className="d-flex">
                    <FormGroup>
                      <Form.Label>{strings.primary_color}</Form.Label>
                      <Form.Control
                        type="color"
                        value={primaryColor}
                        onChange={(e) => setPrimaryColor(e.target.value)}
                      />
                    </FormGroup>

                    <FormGroup className="mx-5">
                      <Form.Label>{strings.secondary_color}</Form.Label>
                      <Form.Control
                        type="color"
                        value={secondaryColor}
                        onChange={(e) => setSecondaryColor(e.target.value)}
                      />
                    </FormGroup>
                  </div>

                  {/* Section: Brand Assets */}
                  <h6 className="mt-3 mb-3 fw-bold">
                    🖼️ {strings.brand_assets}
                  </h6>

                  <Row>
                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "5px" }}>
                        <Form.Label>
                          <EntypoImage size={18} className="me-2" />
                          {strings.background_image}
                        </Form.Label>
                        <div className="d-flex">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="imgInput"
                            onChange={handleBackgroundChange}
                          />
                          <ImageContainer
                            imgSrc={backgroundImage}
                            onDelete={() => {
                              setBackgroundImage(null);
                              setBackgroundImageFile(null);
                            }}
                            alt="Background Preview"
                          />
                        </div>
                      </FormGroup>
                      <div className="mb-3 imgInput">
                        {backgroundImageFile && backgroundImageFile.name && (
                          <p className="p-0 m-0">{backgroundImageFile.name}</p>
                        )}
                      </div>
                    </Col>

                    <Col md={6}>
                      <FormGroup style={{ marginBottom: "5px" }}>
                        <Form.Label>
                          <EntypoImage size={18} className="me-2" />
                          {strings.logo_upload}
                        </Form.Label>
                        <div className="d-flex">
                          <Form.Control
                            type="file"
                            accept="image/*"
                            className="imgInput"
                            onChange={handleLogoChange}
                          />
                          <ImageContainer
                            imgSrc={logoImage}
                            onDelete={() => {
                              setLogoImage(null);
                              setLogoImageFile(null);
                            }}
                            alt="Logo Preview"
                          />
                        </div>
                      </FormGroup>
                      <div className="mb-3 imgInput">
                        {logoImageFile && logoImageFile.name && (
                          <p className="p-0 m-0">{logoImageFile.name}</p>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <div className="d-flex my-3">
                    <p style={{ fontSize: 15 }}>{strings.your_org_name} :</p>
                    <p className="fw-bold mx-1" style={{ fontSize: 15 }}>
                      {organisationName}
                    </p>
                  </div>
                  <Row>
                    <Col md={6}>
                      <label htmlFor="description" className="mb-2">
                        {strings.slug}
                      </label>
                      <InputGroup seamless className="imgInput">
                        <FormInput
                          type="text"
                          id="description"
                          placeholder={strings.slug}
                          value={slug}
                          onChange={(e) => setSlug(e.target.value)}
                        />
                      </InputGroup>
                      {slug && slug.length > 0 && (
                        <p
                          className="imgInput"
                          style={{ marginTop: "3px", color: "#5a6169" }}
                        >
                          {SLUG_URL}
                          {slug}
                        </p>
                      )}
                    </Col>
                    <Col md={6}>

                      <label htmlFor="contactEmail" className="mb-2">
                        {strings.contact_email}
                      </label>
                      <InputGroup seamless className="imgInput">
                        <FormInput
                          type="email"
                          id="contactEmail"
                          placeholder={strings.contact_email}
                          value={contactEmail}
                          onChange={(e) => setContactEmail(e.target.value)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>

                  <Button
                    variant="primary"
                    disabled={isButtonDisabled}
                    onClick={onSaveConfig}
                    className="my-4"
                  >
                    <i
                      className={btnLoaderClass}
                      style={{ fontSize: "15px" }}
                    ></i>{" "}
                    {strings.save}
                  </Button>
                </>
              )}
              <ToastContainer />
            </CardBody>
          </Card>

          {/* FAQ Section */}
          {/* <Card small className="mb-4 faq-card mt-0 border-0 shadow-sm">
            <CardBody className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <PageTitle
                  sm="4"
                  title={strings.faqs || "FAQs"}
                  className="text-sm-left page-title"
                />
                <div className="d-flex gap-2">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={addFaq}
                    className="rounded-pill px-3 py-2 shadow-sm"
                  >
                    <i className="material-icons me-1" style={{ verticalAlign: 'middle', fontSize: '18px' }}>add</i>
                    {strings.create_faq || "Crear FAQ"}
                  </Button>
                </div>
              </div>

              {faqs.length === 0 ? (
                <div className="text-center py-5 border rounded-3 bg-light opacity-75">
                  <span className="material-icons-outlined text-muted mb-3" style={{ fontSize: '48px' }}>help_outline</span>
                  <h5 className="text-muted">No FAQs yet</h5>
                  <p className="text-muted mb-4 small">Click the "Add FAQ" button to start adding questions.</p>
                </div>
              ) : (
                <div className="faqs-list">
                  {faqs.map((faq, faqIndex) => (
                    <div key={faqIndex} className="faq-item-simple border rounded shadow-sm mb-4 overflow-hidden">
                      <div
                        className="d-flex justify-content-between align-items-center p-3 border-bottom"
                        style={{ backgroundColor: "#f8f9fa" }}
                      >
                        <div className="faq-question-text fw-bold text-dark flex-grow-1 pe-3">
                          {faq.question || "New Question"}
                        </div>
                        <div className="d-flex gap-2">
                          <Button
                            variant="success"
                            size="sm"
                            className="rounded px-3 text-white fw-bold shadow-sm"
                            onClick={() => openEditFaqModal(faqIndex)}
                          >
                            {strings.edit || "Edit"}
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            className="rounded px-3 text-white fw-bold shadow-sm"
                            onClick={() => removeFaq(faqIndex)}
                          >
                            {strings.delete || "Delete"}
                          </Button>
                        </div>
                      </div>

                      <div className="faq-answer-container p-3 bg-white">
                        <div className="faq-answer-text">
                          {faq.answer ? (
                            <div className="rich-text-content">
                              {renderHTML(faq.answer)}
                            </div>
                          ) : (
                            <em className="text-muted">No answer provided</em>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </CardBody>
          </Card> */}


          {/* FAQ View/Edit Form Modal */}
          <Modal show={showFaqFormModal} onHide={() => setShowFaqFormModal(false)} centered size="lg" scrollable={true}>
            <Modal.Header closeButton className="border-0 pb-0">
              <Modal.Title className="fw-bold">
                {faqModalData.isNew ? strings.add_faq || "Add FAQ" : strings.edit_faq || "Edit FAQ"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-3">
              <FormGroup className="mb-4">
                <Form.Label className="small fw-bold text-dark mb-2">
                  <span className="material-icons-outlined small me-1 text-primary" style={{ fontSize: '16px', verticalAlign: 'middle' }}>help</span>
                  {strings.question || "Question"}
                </Form.Label>
                <Form.Control
                  type="text"
                  className="form-control-lg fw-bold"
                  placeholder={strings.enter_question || "Enter question..."}
                  value={faqModalData.question}
                  onChange={(e) => setFaqModalData({ ...faqModalData, question: e.target.value })}
                  style={{ border: '1px solid #ced4da', borderRadius: '0.25rem' }}
                />
              </FormGroup>

              <FormGroup className="mb-4">
                <Form.Label className="small fw-bold text-dark mb-2">
                  <span className="material-icons-outlined small me-1 text-success" style={{ fontSize: '16px', verticalAlign: 'middle' }}>question_answer</span>
                  {strings.answer || "Answer"}
                </Form.Label>
                <div className="quill-container border rounded">
                  <ReactQuill
                    theme="snow"
                    value={faqModalData.answer}
                    onChange={(content) => setFaqModalData({ ...faqModalData, answer: content })}
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline", "link"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        // [{ header: [1, 2, false] }],
                        ["clean"],
                      ],
                    }}
                  />
                </div>
              </FormGroup>

            </Modal.Body>
            <Modal.Footer className="border-0 pt-0 pb-3 pe-4">
              <Button variant="light" onClick={() => setShowFaqFormModal(false)} className="rounded-pill px-4">
                {strings.cancel || "Cancel"}
              </Button>
              <Button variant="primary" onClick={handleSaveFaqFromModal} className="rounded-pill px-5 fw-bold shadow-sm">
                {strings.save || "Save"}
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
    </SContainer>
  );
};

export default RestaurantConfig;
